import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { DataRoomContext } from '../DisplayDataRoom';
import { Card, ListGroup, Button } from 'react-bootstrap';
import { formatDate } from '../../utils/Date';
import { TEAM_URL } from '../../utils/urls';
import './TeamCard.css';

function TeamCard({ member, canEdit, onEdit }) {
    const { t } = useTranslation();
    const dataroom_id = useContext(DataRoomContext);

    return (
        <Card className="team-card">
            <div className="team-card-header">
                <div className="team-card-image-wrapper">
                    <Card.Img variant="top" src={member.picture_url} className="team-card-image" />
                </div>
                <div className="team-card-info">
                    <Card.Title className="team-card-name">
                        <Link to={TEAM_URL.replace(':dataroomId', dataroom_id).replace(':teamId', member.user_id)}>
                            {member.username}
                        </Link>
                    </Card.Title>
                    <Card.Text className="team-card-role">
                        {member.role.role_name}
                    </Card.Text>
                </div>
            </div>
            <Card.Body>
                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <i className="bi bi-globe"></i> 
                        <a href={member.company_url} target="_blank" rel="noreferrer">{member.company_name}</a>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <i className="bi bi-collection"></i> 
                        {member.groups ? 
                            member.groups.map(group => group.folder_name ? `${group.folder_name} (${group.group_name})` : group.group_name).join(', ') : 
                            "No groups"}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <i className="bi bi-file-earmark"></i> {`${member.file_count} ${t('pages.documents.addedDocuments')}`}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <i className="bi bi-chat-dots"></i> {`${member.comment_count} ${t('comment.addedComment')}`}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <i className="bi bi-clock-history"></i> {t('general.connected')} {formatDate(member.last_connection, t).toLowerCase()}
                    </ListGroup.Item>
                </ListGroup>
            </Card.Body>
            <Card.Footer>
                <Button variant="link" href={`mailto:${member.email}`}>
                    <i className="bi bi-envelope"></i> Contact
                </Button>
                {canEdit && (
                    <Button variant="primary" onClick={() => onEdit(member)}>
                        <i className="bi bi-pencil "></i> {t('general.edit')}
                    </Button>
                )}
            </Card.Footer>
        </Card>
    );
};

export default TeamCard;